import { connect } from 'react-redux';

import CrudForm from './CrudForm';

const mapStateToProps = state => {
  return {
    drawerTitle: state.rolesPermissions.drawerTitle,
  };
};

export default connect(mapStateToProps)(CrudForm);
